import HTTP from "../../http";

const PAYMENTS_ENDPOINT = "/payments";
const PAYMENTS_PAYMENT_METHOD_ENPOINT = "/payment_method/";

export async function addPaymentMethod(order_id, store_id, payment_method) {
  return await HTTP.post(PAYMENTS_ENDPOINT + PAYMENTS_PAYMENT_METHOD_ENPOINT, {
    order_id,
    store_id,
    payment_method
  });
}
